// extracted by mini-css-extract-plugin
export default {"controls":"masterControls_controls__CH8AY","controlsDark":"masterControls_controlsDark__-yq6W"};